import request from '@/utils/request'

// 订单列表
export function fetchGoodsInfo(params) {
	return request({
		url: '/oms/goods/auto/base',
		method: 'GET',
		params: params
	})
}

// 商品图片
export function fetchGoodsImages(params) {
	return request({
		url: '/oms/goods/auto/image',
		method: 'GET',
		params: params
	})
}

// 获取商品主图
export function fetchGoodsMainImages(params) {
	return request({
		url: '/oms/goods/img/list',
		method: 'GET',
		params: params
	})
}

// 店铺列表
export function fetchShopList(params) {
	return request({
		url: '/oms/goods/shopList',
		method: 'GET',
		params: params
	})
}

// 1688店铺信息
export function fetch1688ShopInfo(params) {
	return request({
		url: '/oms/supp/get1688AndSave',
		method: 'GET',
		params: params
	})
}

// 类目列表
export function fetchCategoryList(params = {parentId: 0}) {
	return request({
		url: '/oms/cat/list',
		method: 'GET',
		params: params
	})
}

// 保存基础信息
export function saveBaseInfo(data) {
	return request({
		url: '/oms/goods/saveOrUpdate',
		method: 'POST',
		data
	})
}

// 翻译
export function translateGoodsName(params) {
	return request({
		url: '/oms/goods/translate',
		method: 'GET',
		params
	})
}

// 主图上传
export function uploadGoodsImg(data) {
	return request({
		url: '/oms/goods/img/upload',
		method: 'POST',
		data
	})
}

// 详情图上传
export function uploadDetailGoodsImg(data) {
	return request({
		url: '/oms/goods/uploadGoodsDetailImg',
		method: 'POST',
		data
	})
}


// 自动获取商品属性信息
export function getGoodsSpu(params) {
	return request({
		url: '/oms/goods/auto/spu',
		method: 'GET',
		params
	})
}

// 查看商品的尺码信息
export function getGoodsSize(params) {
	return request({
		url: '/oms/size/list',
		method: 'GET',
		params
	})
}

// 根据商品属性生成SKU
export function generateSkuList(data) {
	return request({
		url: '/oms/sku/generateSku',
		method: 'POST',
		data
	})
}

// 根据商品ID，获取类目信息
export function getCategoryInfoByGoodsId(params) {
	return request({
		url: '/oms/cat/getByGoodsId',
		method: 'GET',
		params
	})
}

// 根据前面接口返回的类目ID信息，获取尺码表最左边一列的展示信息
export function getAttrListByCatId(params) {
	return request({
		url: '/oms/size/listByCatId',
		method: 'GET',
		params
	})
}

// 批量增加尺码表信息，接口传参简化了一下
export function batchSave(data) {
	return request({
		url: '/oms/size/batchSaveOrUpdate',
		method: 'POST',
		data
	})
}

// 获取商品的尺码信息
export function getSizeList(params) {
	return request({
		url: '/oms/size/list',
		method: 'GET',
		params
	})
}

// 修改SKU信息
export function updateSkuList(data) {
	return request({
		url: '/oms/sku/updateSku',
		method: 'POST',
		data
	})
}

// 修改折后价
export function updateManual(data) {
	return request({
		url: '/oms/goods/price/manual',
		method: 'POST',
		data
	})
}
// 商品上架
export function onSale(data) {
	return request({
		url: '/oms/goods/saveOrUpdate',
		method: 'POST',
		data
	})
}

// 商品图片批量下载
export function imgDownload(params) {
	return request({
		url: '/oms/goods/img/1688/list',
		method: 'GET',
		params
	})
}

// 商品主图删除
export function mainImgDelete(params) {
	return request({
		url: '/oms/goods/img/delete',
		method: 'GET',
		params
	})
}

// 商品主图排序
export function mainImgSort(data) {
	return request({
		url: '/oms/goods/img/sort',
		method: 'POST',
		data
	})
}

// 获取商品sku
export function getGoodsSku(params) {
	return request({
		url: '/oms/sku/listByGoodsId',
		method: 'GET',
		params
	})
}

// 预览商品规格组合
export function previewSkuCombinations(data) {
	return request({
		url: '/oms/sku/previewCombinations',
		method: 'POST',
		data
	})
}

// 商品与SKU一体化保存
export function saveGoodsWithSkus(data) {
	return request({
		url: '/oms/goods/saveOrUpdateWithSkus',
		method: 'POST',
		data
	})
}

export function addSkuSpecValue(data) {
	return request({ url: '/oms/sku/spec/value', method: 'POST', data })
}

// 编辑SKU
export function generateEditSkuList(data) {
	return request({
		url: '/oms/sku/platform/generate',
		method: 'POST',
		data
	})
}

// 编辑SKU {"skuId":23285, "onSale":0}    onSale  1上架 0下架
export function editSkuSaleStatus(data) {
	return request({
		url: '/oms/sku/onOrOffSale',
		method: 'POST',
		data
	})
}

// 根据商品获取商品标签列表
export function getAttrList(params) {
	return request({
		url: '/oms/goods/attribute/listByCatId',
		method: 'GET',
		params
	})
}

// 获取站点列表
export function siteList(params) {
	return request({
		url: '/oms/goods/site/list',
		method: 'GET',
		params
	})
}

// 售卖平台列表
export function listPlatform(params){
	return request({
		url: '/oms/goods/platform/list',
		method: 'GET',
		params
	})
}


// 获取供方货源 /oms/sku/pas/list
export function pasList(params) {
	return request({
		url: '/oms/sku/pas/list',
		method: 'GET',
		params
	})
}



// WEBPACK FOOTER //
// ./src/api/oms/goods.js